import { render, staticRenderFns } from "./UploadVideo.vue?vue&type=template&id=a004109e&scoped=true"
import script from "./UploadVideo.vue?vue&type=script&lang=js"
export * from "./UploadVideo.vue?vue&type=script&lang=js"
import style0 from "./UploadVideo.vue?vue&type=style&index=0&id=a004109e&prod&lang=css"
import style1 from "./UploadVideo.vue?vue&type=style&index=1&id=a004109e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a004109e",
  null
  
)

export default component.exports